import fr from 'facet-rest';

export const getAccountCreationRequestSummaryFilters = (collection, householdSearch) => [
  {
    name: 'accountTitle', // string
    query: 'getAccountCreationRequestSummaries',
    overrideOperators: ['like'],
  },
  {
    name: 'householdId', // picklist
    overrideOptions: householdSearch ? householdSearch.map(search => ({
      name: `${search.attributes.primaryClientFirstName} ${search.attributes.primaryClientLastName} [${search.id}]`,
      value: search.id.toString(),
    })) : [],
    query: 'getAccountCreationRequestSummaries',
    _setQueryParam: true,
  },
  {
    name: 'status', // multi-picklist
    query: 'getAccountCreationRequestSummaries',
    overrideOperators: ['in'],
  },
  {
    name: 'startDate',
    query: 'getAccountCreationRequestSummaries',
  },
  {
    name: 'endDate',
    query: 'getAccountCreationRequestSummaries',
  },
  {
    name: 'hidden',
    query: 'getAccountCreationRequestSummaries',
  },
];

export const defaultAccountCreationRequestSummaryFilters = {
  householdId: {
    value: '',
  },
  hidden: {
    value: 'false',
  },
  status: {
    value: ['SUSPENDED', 'ACTION_REQUIRED'],
  },
};

export const AccountCreationRequestSummaryOverride = fr.metaOverride()
  .nameOverride('householdId', { ordinal: 1 })
  .nameOverride('accountId', { ordinal: 2 })
  .nameOverride('requestId', { ordinal: 3 })
  .nameOverride('status', { ordinal: 4 })
  .nameOverride('lastSynced', { ordinal: 5 })
  .nameOverride('accountTitle', { ordinal: 6 })
  .nameOverride('total', { ordinal: 7 })
  .nameOverride('totalDeposits', { ordinal: 8 })
  .nameOverride('totalDisbursements', { ordinal: 9 })
  .nameOverride('unAdjustedTotal', { ordinal: 10 })
  .nameOverride('startDayCashAvailable', { ordinal: 11 })
  .nameOverride('pendingDebitInterest', { ordinal: 12 })
  .nameOverride('pendingDebitDividends', { ordinal: 13 })
  .nameOverride('fullyPaidUnsettledFunds', { ordinal: 14 })
  .nameOverride('includesFullyPaidUnsettledFunds', { ordinal: 15 });
